import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const Ctx = createContext(null);
export const useAuth = () => useContext(Ctx);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const refreshMe = () =>
    api.get("/auth/me").then((r) => setUser(r.data)).catch(async () => {
      try {
        const { data } = await api.post("/auth/refresh");
        localStorage.setItem("ilmora-token", data.access_token);
        const r = await api.get("/auth/me");
        setUser(r.data);
      } catch {
        setUser(false);
      }
    });

  useEffect(() => { refreshMe(); }, []);

  const handle = (data) => { localStorage.setItem("ilmora-token", data.access_token); setUser(data.user); return data.user; };
  const login = (email, password) => api.post("/auth/login", { email, password }).then((r) => handle(r.data));
  const register = (payload) => api.post("/auth/register", payload).then((r) => handle(r.data));
  const logout = async () => { await api.post("/auth/logout").catch(() => {}); localStorage.removeItem("ilmora-token"); setUser(false); };

  return <Ctx.Provider value={{ user, login, register, logout, refreshMe }}>{children}</Ctx.Provider>;
};

export const Protected = ({ children, admin }) => {
  const { user } = useAuth();
  if (user === null) return <div className="py-40 grid place-items-center"><Loader2 className="animate-spin text-[var(--pink)]" size={32} /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
};
